import { useEffect, useState, useForm } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaPen, FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import useToken from '../../useToken';
import config from '../../config/config';
import axios from 'axios';
import { Link } from 'react-router-dom';

function OriginList() {
  const [error, setError] = useState(null);
  const [origin, setOrigin] = useState([]);
  const { token, auth } = useToken();

  function deleteOrigin(id) {
    axios
      .delete(`${config.deleteUrl}/origin/${id}`, { params: { id: id } })
      .then((response) => {
        setOrigin((origin) => origin.filter((x) => x.id !== id));
      });
  }
  useEffect(() => {
    var auth = auth;
    axios.get(`${config.getUrl}/origin`).then((res) => {
      setOrigin(res.data);
    });
  }, []);

  return (
    <div className="col-lg-12 mt-5">
      <Link className="btn lpbgColor mb-3" to="/origin/addorigin">
        Add Origin
      </Link>
      <div className="card o-hidden border-0 shadow-sm "> 
      <table className="table table-striped mb-0">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {origin.map((i) => (
            <tr key={i.id}>
              <td>{i.name}</td>
              <td>
                <Link
                  className="text-primary mr-2"
                  to={`/origin/editorigin/${i.id}`}
                >
                  <FaPen />
                </Link>
                <a onClick={() => deleteOrigin(i.id)} className="text-danger">
                  <FaTrash />
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  );
}

export default OriginList;
